import { Video } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function VideoPreparationNotice({ compact = false }) {
  const { user } = useAuth();
  const firstTime = user?.video_setup_completed !== true;

  if (!firstTime) {
    return (
      <div className={`rounded-xl border border-brand-line-strong bg-brand-soft ${compact ? "p-3" : "p-4"}`} data-testid="video-preparation-reminder">
        <div className="flex items-start gap-3">
          <Video size={17} className="mt-0.5 shrink-0 text-brand-fresh"/>
          <div>
            <div className="text-sm font-semibold text-brand-ink">Gør dig klar</div>
            <p className="mt-0.5 text-xs text-brand-body">Test kamera og mikrofon før samtalen.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`rounded-xl border border-brand-line bg-brand-wash ${compact ? "p-3" : "p-4"}`} data-testid="first-video-preparation-guidance">
      <div className="flex items-start gap-3">
        <Video size={18} className="mt-0.5 shrink-0 text-brand-fresh"/>
        <div>
          <div className="text-sm font-semibold text-brand-ink">Første videosamtale?</div>
          <p className="mt-1 text-sm leading-5 text-brand-body">Vi anbefaler, at du åbner samtalen 10–15 minutter før, så du kan teste kamera, mikrofon og lyd i ro og mag.</p>
          <p className="mt-2 text-xs font-medium text-brand-fresh">Opsætningstiden før selve konsultationen starter tæller ikke som konsultationstid.</p>
        </div>
      </div>
    </div>
  );
}

